import { InjectionToken } from '@angular/core';
import { AppInsightsConfigModel } from '@omaxel/angular-ms-app-insights';
import { AuthConfig } from 'angular-oauth2-oidc';

export interface Environment {
    production: boolean;
    apiUrl: string;
    logging: AppInsightsConfigModel;
    auth?: AuthConfig;
    sessionPollingIntervalMilliseconds: number;
    version: string;
    recaptcha: {
        siteKey: string;
    };
    clarityProjectId?: string;
    activeCampaignAccountId?: string;
    jiraIssueCollector: {
        helpCenter: {
            url: string;
            customFieldKeys: {
                username: string;
                language: string;
            };
        };
        ambassadorInfo: {
            url: string;
            customFieldKeys: {
                language: string;
            };
        };
    };
    htmlFontSize: number;
    googleTagManagerId?: string;
    googleMapsApiKey?: string;
    novu: {
        applicationId: string;
        apiUrl: string;
        socketUrl: string;
    };
}

export const ENVIRONMENT: InjectionToken<Environment> = new InjectionToken('ENVIRONMENT');
